
import { useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { useAppDispatch } from "@/store/hooks";
import { OpenAddClientPubSub, OpenAddClientPubSubPayload } from "@utils/pubsubs/PubSub";
import ClientForm from "@components/forms/ClientForm";
import { ClientDataType } from "@/api/ClientApi";

type AddClientOffCanvasProps = {
    onStored: (clientData?: ClientDataType) => void
} & DefaultOffCanvasProps

const AddClientOffCanvas = (props: AddClientOffCanvasProps) => {
    const { btnColor = "primary", className, onStored } = props;
    const [isOpen, setOpen] = useState(false);
    // const [searchType, setSearchType] = useState<SearchType>("");

    useEffect(() => {
        const unsubscribe = OpenAddClientPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenAddClientPubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
    }


    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const onClientStored = (clientData?: ClientDataType) => {
        setOpen(false);
        if (onStored) {
            onStored(clientData)
        }
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Crear Cliente
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <ClientForm
                            onStored={onClientStored}
                            formId="addClient"
                        />
                    </Container>
                </OffcanvasBody>
                <div className={styles.footerButtons}>
                    <Button color="primary" form="addClient">
                        Guardar
                    </Button>
                </div>
            </DefaultOffCanvas >
        </>
    );
}
export default AddClientOffCanvas;
